import { TagIcon } from '@/components/icons/tag-icon';
import AccordionFilter from '@/components/ui/accordion-filter';
import { useAIModels } from '@/data/aiModels';
import { useCategories } from '@/data/category';
import { useTagsQuery } from '@/data/tag';
import { generateCategorySlugPath } from '@/data/utils/utils';
import {
  Accordion,
  AccordionItem,
} from '@nextui-org/react';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';

const fixTags = [
  'Animal',
  'Adult',
  'Child',
  'Baby',
  'Environment',
  'Nature',
  'Flowers & Plants',
  'Vehicles',
  'Food & Beverages',
  'For Children',
  'Letters',
  'Products',
  'Music',
  'Entertainment',
  'Celebrity',
  'Sports',
  'Business',
  'Politics',
  'Photography',
  'Interior',
];


function createTagSlug(text: string) {
  return text
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

const ProductFilterAccordions = () => {
  const router = useRouter();
  const { categories } = useCategories();
  const { aiModels } = useAIModels();
  const { tags } = useTagsQuery({
    limit: 1000,
    language: router.locale,
  });

  const tagsFiltered = useMemo(() => fixTags.map(createTagSlug), []);
  const filteredTags = useMemo(
    () => tags?.filter((tag) => tagsFiltered.includes(tag.slug)),
    [tags]
  );
  const sortedAIModels = useMemo(
    () =>
      aiModels?.sort((a, b) => a!.name.localeCompare(b!.name)),
    [aiModels]
  );
  const sortedCategories = useMemo(
    () => categories.sort((a, b) => a!.name.localeCompare(b!.name)),
    [categories]
  );

  const [selectedKeys, setSelectedKeys] = useState(
    new Set(['0', '1', '2', '3'])
  );
  return (
    <Accordion
      selectedKeys={selectedKeys}
      onSelectionChange={setSelectedKeys}
      selectionMode="multiple"
      className="divider-custom-black dark:divider-custom-light"
      disableAnimation
    >
      <AccordionItem
        key="0"
        aria-label="Refine by"
        title="Refine by"
        //   startContent={
        //     <svg
        //       xmlns="http://www.w3.org/2000/svg"
        //       fill="none"
        //       viewBox="0 0 24 24"
        //       strokeWidth={1.5}
        //       stroke="currentColor"
        //       className="h-6 w-6"
        //     >
        //       <path
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //         d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
        //       />
        //     </svg>
        //   }
        // >
      >
        <AccordionFilter
          queryParamName="refineBy"
          items={[
            {
              id: 'prompt',
              name: 'Prompt',
              label: 'Prompt',
              value: 'prompt',
            },
            {
              id: 'generator',
              name: 'Generator',
              label: 'Generator',
              value: 'generator',
            },
          ]}
        />
      </AccordionItem>
      <AccordionItem
        key="2"
        aria-label="Categories"
        title="Categories"
        startContent={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
            />
          </svg>
        }
      >
        <AccordionFilter
          // key={router.query.types + '.categories'}
          queryParamName="categories"
          items={sortedCategories.map((category) => ({
            ...category,
            label: category.name,
            value: generateCategorySlugPath(category),
          }))}
        />
      </AccordionItem>
      <AccordionItem
        key="1"
        aria-label="AI Models"
        title="AI Models"
        startContent={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
            />
          </svg>
        }
      >
        <AccordionFilter
          // key={router.query.types + '.aiModels'}
          queryParamName="aiModels"
          items={sortedAIModels.map((aiModel) => ({
            ...aiModel,
            label: aiModel.name ?? aiModel.slug,
            value: aiModel.slug,
          }))}
        />
      </AccordionItem>
      <AccordionItem
        key="3"
        aria-label="Tags"
        title="Tags"
        startContent={<TagIcon />}
      >
        <AccordionFilter
          // key={router.query.types + '.tags'}
          queryParamName="tags"
          items={filteredTags.map((tag) => ({
            ...tag,
            label: tag.name,
            value: tag.slug,
          }))}
        />
      </AccordionItem>
      {/* <AccordionItem key="4" aria-label="Styles" title="Styles">
                  {defaultContent}
                </AccordionItem> */}
    </Accordion>
  );
};

export default ProductFilterAccordions;
